import { AxiosError } from "axios";
import { TERMS_REACCEPTANCE_REQUIRED } from "../../constants/apiConstants";

export interface iTermsGateDetail {
	version: string;
	effectiveAt: string;
}

/**
 * Recognises Baqaal's terms-gate 403 and pulls out the detail the gate needs.
 *
 * Matches on `data.reason` — a backend constant published precisely so clients
 * can branch on it — never on the message text, which is human-readable copy
 * and free to change.
 *
 * Returns null for every other 403, including the accept endpoint's
 * `TERMS_ACCEPT_SUPER_ADMIN_ONLY`, which carries no `reason` and must be
 * handled by the accept flow rather than by opening the gate.
 */
export const getTermsGateDetail = (error: AxiosError): iTermsGateDetail | null => {
	if (error.response?.status !== 403) {
		return null;
	}

	const gate = (
		error.response.data as {
			data?: { reason?: string; version?: string; effectiveAt?: string };
		}
	)?.data;

	if (gate?.reason !== TERMS_REACCEPTANCE_REQUIRED) {
		return null;
	}

	return {
		version: gate.version ?? "",
		effectiveAt: gate.effectiveAt ?? "",
	};
};
